import compact from 'lodash/compact';
import map from 'lodash/map';

export function librariesArrayToMap(arrayOfLibs = []) {
  if (!Array.isArray(arrayOfLibs)) {
    return {};
  }
  return arrayOfLibs.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.library.id]: {
        referenceName: curr.referenceName,
        id: curr.id,
        selected: true, // All true on load (else they won't be part of this map yet)
      },
    }),
    {},
  );
}

/**
 * Convert a map of library uuids/reference names to an array
 * @param {LibraryMap} mapOfLibReferenceNames
 * @returns {[LibraryReference]}
 */
export function librariesMapToArray(
  mapOfLibReferenceNames,
  currentlyOpenedLibrary,
) {
  const getLibraryData = (id, referenceName, nestedId = id) => ({
    referenceName,
    id,
    library: { id: nestedId },
  });

  // `mapOfLibReferenceNames` contains `referenceName` and `selected`, but nothing else (no id) so wrapping to keep access to both:
  const getNullableLibraryData = (mapLibrary, mapKey) => {
    if (!mapLibrary.selected) {
      return null;
    }
    // Missing libraryId implies a newly created library, in which case sub in the currently open one:
    if (mapKey === '') {
      const { id, name } = currentlyOpenedLibrary;
      return getLibraryData(id, name);
    }
    const { referenceName, id } = mapLibrary;
    return getLibraryData(id, referenceName, mapKey);
  };

  return compact(map(mapOfLibReferenceNames, getNullableLibraryData));
}
